import { RouteObject } from "react-router-dom";
import { NotFound } from "src/routes/NotFound";
import { AddProductOfferingConfigPage } from "src/routes/libraries/product-offering-configs/AddProductOfferingConfigPage";
import { ProductOfferingConfigsPage } from "src/routes/libraries/product-offering-configs/ProductOfferingConfigsPage";
import { AppShell } from "src/routing/components/AppShell";
import { GlobalNavLayout } from "src/routing/components/layouts/GlobalNavLayout";
import { ScrollableParentLayout } from "src/routing/components/layouts/ScrollableParentLayout";
import * as productOfferingConfigsPaths from "src/routing/domains/libraries/product-offering-configs/productOfferingConfigsPaths";

/**
 * `/libraries/product-offering-configs/*` route tree.
 *
 * Role: data router domain route.
 *
 * Default stack: `AppShell` → `GlobalNavLayout` → `ScrollableParentLayout` → page.
 */
export const productOfferingConfigsRoute: RouteObject = {
  path: productOfferingConfigsPaths.globalProductOfferingConfigsRoute.path,
  Component: AppShell,
  children: [
    {
      Component: GlobalNavLayout,
      children: [
        {
          Component: ScrollableParentLayout,
          children: [
            { index: true, Component: ProductOfferingConfigsPage },
            {
              path: productOfferingConfigsPaths.productOfferingConfigEditRoute.path,
              Component: AddProductOfferingConfigPage,
            },
            {
              path: productOfferingConfigsPaths.productOfferingConfigRoute.path,
              Component: AddProductOfferingConfigPage,
            },
          ],
        },
      ],
    },
    { path: "*", Component: NotFound },
  ],
};
